module.exports = __webpack_public_path__ + "img/marketing_info.6759f7c7.png";